
// @ts-nocheck
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */




const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`How to Version and Export Components`}</h2>
    <blockquote>
      <p parentName="blockquote">{`To export your components to the cloud so that they can be installed elsewhere you first have to tag and then export your components.`}</p>
    </blockquote>
    <p>{`When we version or 'tag' a component, we commit changes and prepare it to be exported to a remote scope. This process most often includes compiling and testing, as well.`}</p>
    <h3>{`How to Tag a component`}</h3>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`bit tag <component-id> --patch --message "this is the tag message"
`}</code></pre>
    <h4>{`How to Tag all components that have been modified`}</h4>
    <p>{`Tag all components and bump the patch number of each component version`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`bit tag --all
`}</code></pre>
    <h3>{`How to Export your Components`}</h3>
    <p>{`Once you have tagged your component you can then run the bit export command.`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`bit export
`}</code></pre>
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://harmony-docs.bit.dev/building-with-bit/versioning-components"
          }}>{`Learn more on Versioning Components`}</a></p>
      </li>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "https://harmony-docs.bit.dev/building-with-bit/exporting-components"
          }}>{`Learn more on Exporting Components`}</a></p>
      </li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;